export class IAMObject {
    organsiation_id: string;
    organsiation_name: string;
    uid: string;
    constructor(
        organsiation_id: string,
        organsiation_name: string,
        uid: string,
    ) {
        this.organsiation_id = organsiation_id;
        this.organsiation_name = organsiation_name;
        this.uid = uid;
    }

    static fromJSON(iamObject: any): IAMObject {
        const iamObjectInfo = new IAMObject('', '', '');
        if (iamObject) {
            iamObjectInfo.organsiation_id = iamObject.organsiation_id ? iamObject.organsiation_id : '';
            iamObjectInfo.organsiation_name = iamObject.organsiation_name ? iamObject.organsiation_name : '';
            iamObjectInfo.uid = iamObject.uid ? iamObject.uid : '';
        }

        return iamObjectInfo
    }
}